import { colors } from '@everlywell/leaves';

export const PRODUCT_BADGES = {
  NEW: { text: 'New', color: colors.teal4 },
  SALE: { text: 'Sale', color: colors.red2 },
};
